import { useState, useEffect, useRef } from "react";
import ActivitiesToolbar from "./ActivitiesToolbar";
import ActivitiesTable from "./ActivitiesTable";
import Pagination from "../components/Pagination";
import { formatTimeMinutes } from "../../components/CommonFunction/CommonFunction";
import api, { BASE_URL } from "../../../src/api_interceptor/api";
import Loader from "../../components/loader/Loader";
import GenericModal from "../components/GenericModal";
import { get } from "jquery";
import { useNavigate, useLocation } from "react-router-dom";

const Activities = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [activities, setActivities] = useState([]);
  const hasFetched = useRef(false);
  const suppressPageFetch = useRef(false);
  const skipSearchEffect = useRef(true);
  const skipClientTypeEffect = useRef(true);
  const skipPageEffect = useRef(true);
  const [searchActivity, setSearchActivity] = useState("");
  // 1 = Enterprise (default), 2 = Site
  const [clientTypeId, setClientTypeId] = useState(1);
  const [editErrorOpen, setEditErrorOpen] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [pageLength] = useState(10);
   
  //const [totalRecords, setTotalRecords] = useState(0);

  const [modalState, setModalState] = useState({
    open: false,
    title: "",
    description: "",
    type: "success", // success | error | warning
  });

  const showError = (message) => {
    setModalState({
      open: true,
      title: "Error",
      description: message || "Something went wrong. Please try again.",
      type: "error",
    });
  };
  const showWarning = (message) => {
    setModalState({
      open: true,
      title: "Action Not Allowed",
      description: message,
      type: "warning",
    });
  };

  const resetToFirstPageAndFetch = () => {
    if (currentPage !== 1) {
      suppressPageFetch.current = true;
      setCurrentPage(1);
    }
    getActivityList(1);
  };

  useEffect(() => {
    if (hasFetched.current) return;
    hasFetched.current = true;
    getActivityList(1);
  }, []);

  useEffect(() => {
    if (skipSearchEffect.current) {
      skipSearchEffect.current = false;
      return;
    }
    const delay = setTimeout(() => {
      resetToFirstPageAndFetch();
    }, 400); // debounce search

    return () => clearTimeout(delay);
  }, [searchActivity]);

  useEffect(() => {
    if (skipClientTypeEffect.current) {
      skipClientTypeEffect.current = false;
      return;
    }
    resetToFirstPageAndFetch();
  }, [clientTypeId]);

  useEffect(() => {
    if (skipPageEffect.current) {
      skipPageEffect.current = false;
      return;
    }
    if (suppressPageFetch.current) {
      suppressPageFetch.current = false;
      return;
    }
    getActivityList();
  }, [currentPage]);

 const getActivityList = (pageOverride) => {
  setIsLoading(true);
  const API_URL = "api/GetAllActivities";
  const page = pageOverride ?? currentPage;
  const req_body = {
    filter: searchActivity || "",
    pageIndex: page - 1,
    totalPage: totalPages,
    pageLength: pageLength, 
    errorMessage: "",
    Type: "Activity",
    SortAction: "None",
    ClientTypeId: clientTypeId,
  };

  api
      .post(API_URL, req_body, {
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true,
      })
    .then((response) => {
      setIsLoading(false);
      if (response && response.data) {
          // Check if AllActivityList exists first - if data exists, treat as success
          if (
            response.data.AllActivityList !== undefined &&
            response.data.AllActivityList !== null
          ) {
            setActivities(response.data.AllActivityList);
            setTotalPages(response.data.totalPage || 1);
          } else if (
            response.data.errorMessage &&
            response.data.errorMessage.toLowerCase() !== "success"
          ) {
            const errorMsg =
              response.data.errorMessage === "Exception"
                ? "An error occurred while loading role list. Please try again."
                : response.data.errorMessage || "Failed to load role list.";
            showError(errorMsg);
          } else {
            setActivities([]);
          }
        } else {
          showError("Invalid response from server. Please try again.");
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error("Get Activity list error:", error);

        if (error.code === "ERR_NETWORK" || error.message === "Network Error") {
          showError(
            "Unable to connect to server. Please check your internet connection."
          );
        } else if (error.response) {
          const errorMsg =
            error.response.data?.Message ||
            "Failed to load activity list. Please try again.";
          showError(errorMsg);
        } else {
          showError("An unexpected error occurred. Please try again.");
        }
      });
  };

     


  //     if (response && response.data) {
  //       // Check if AllActivityList exists first - if data exists, treat as success
  //       // This prioritizes data existence over errorMessage check
  //       if (response.data.AllActivityList !== undefined && response.data.AllActivityList !== null) {
  //         setActivities(response.data.AllActivityList);

  //         setTotalRecords(
  //         response.data.TotalRecords || response.data.totalRecords || response.data.AllActivityList.length);

  //       } else if (response.data.errorMessage && response.data.errorMessage.toLowerCase() !== "success") {
  //         // Only show error if errorMessage exists and is not "Success" (case-insensitive)
  //         const errorMsg = response.data.errorMessage === "Exception" 
  //           ? "An error occurred while loading Activity list. Please try again." 
  //           : response.data.errorMessage || "Failed to load Activity list.";
  //         showError(errorMsg);
  //         setActivities([]);
  //         setTotalRecords(0);
  //       } else {
  //         setActivities([]);
  //         setTotalRecords(0);
  //   }
  // }
  //   else {
  //         showError("Invalid response from server. Please try again.");
  //          setActivities([]);
  //          setTotalRecords(0);
  //       }
  //   })
  //   .catch((error) => {
  //     setIsLoading(false);
  //     console.error("Get Activity list error:", error);

  //     if (error.code === 'ERR_NETWORK' || error.message === 'Network Error') {
  //         showError("Unable to connect to server. Please check your internet connection.");
  //       } else if (error.response) {
  //         const errorMsg = error.response.data?.Message || "Failed to load client list. Please try again.";
  //         showError(errorMsg);
  //       } else {
  //         showError("An unexpected error occurred. Please try again.");
  //       }
  //     });

  // };

  //   const totalRecords = activities.length;
  // const totalPages = Math.ceil(totalRecords / pageSize);

  // const paginatedActivities = activities.slice(
  //   (currentPage - 1) * pageSize,
  //   currentPage * pageSize
  // );
  //  const [activities] = useState([
  //   {
  //     id: 1,
  //     code: "M1-A1",
  //     type: "System",
  //     name: "Room Cleaning Schedule",
  //     description: "Automatically generates daily cleaning tasks for hospital rooms.",
  //     moduleCode: "M1",
  //     moduleName: "EVS",
  //   },
  //   {
  //     id: 2,
  //     code: "M1-A2",
  //     type: "Non System",
  //     name: "Bio-waste Pickup Request",
  //     description: "User-initiated request for hazardous waste removal.",
  //     moduleCode: "M1",
  //     moduleName: "EVS",
  //   },
  //     {
  //     id: 3,
  //     code: "M2-A1",
  //     type: "Non System",
  //     name: "Dietary Requirements Check",
  //     description: "User-initiated request for dietary accommodations.",
  //     moduleCode: "M2",
  //     moduleName: "Food Services",
  //   },
  // ]);



  return (
    <>
      {isLoading && <Loader />}

      <div className="bg-white p-4 rounded-lg flex flex-col h-full min-h-0">
        <div className="mb-4">
          <h1 className="text-2xl font-semibold">Activities</h1>
          <p className="text-base text-primary">Activities</p>
        </div>

        <ActivitiesToolbar
          setSearchActivity={setSearchActivity}
          clientTypeId={clientTypeId}
          setClientTypeId={setClientTypeId}
        />

        
        <div className="flex-1 min-h-0">
          <ActivitiesTable
            data={activities}
          //onToggleStatus={handleToggleStatus}
          //onEditClient={handleEditClient}
          />
        </div>

        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          totalRecords={activities.length}
          onPageChange={(newPage) => {
            setCurrentPage(newPage);
          }}

        />

      </div>

      <GenericModal
        open={modalOpen}
        title="Information"
        description="No activities found for the given search."
        primaryText="OK"
        loading={isLoading}
        onPrimary={() => {
          setModalOpen(false);
        }}
        onClose={() => {
          setModalOpen(false);
        }}
      />
      
    </>
  );
};


export default Activities;